module.exports = __webpack_public_path__ + "static/final-trophy-large-579160daf02e6af2080e705bb9412e03.jpg";